import { useState } from 'react';

const fmtDate = (d) => new Date(d).toLocaleString('es-CO', {
  timeZone: 'America/Bogota', dateStyle: 'medium', timeStyle: 'short'
});

const fmtCOP = (n) => new Intl.NumberFormat('es-CO', {
  style: 'currency', currency: 'COP', maximumFractionDigits: 0
}).format(n);

/**
 * Confirmación del borrado definitivo de una cita no atendida.
 *
 * Pide el motivo (queda en la auditoría y en el pago). Si la cita estaba
 * pagada lo advierte: el backend marca el pago como reembolsado, pero el
 * dinero no vuelve solo al paciente.
 */
export default function DeleteAppointmentModal({ appointment, onClose, onConfirm }) {
  const [reason, setReason]   = useState('');
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');

  const isPaid  = appointment.payment?.status === 'paid';
  const patient = appointment.patient?.user;
  const patientName = patient
    ? `${patient.profile?.firstName || ''} ${patient.profile?.lastName || ''}`.trim()
    : '—';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) return;
    setSaving(true);
    setError('');
    try {
      await onConfirm(reason.trim());
    } catch (err) {
      setError(err.response?.data?.message || 'Error al eliminar la cita');
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" role="dialog" aria-modal="true" aria-labelledby="delete-appt-title">
        <div className="modal-header">
          <h2 id="delete-appt-title">Eliminar cita</h2>
          <button className="btn-close" onClick={onClose} aria-label="Cerrar">×</button>
        </div>

        <p className="delete-appt-summary">
          {fmtDate(appointment.scheduledDate)} · {patientName}
        </p>

        <div className="alert alert-warning">
          La cita se borra definitivamente: deja de aparecer en la agenda y en las
          estadísticas. Esto no se puede deshacer.
        </div>

        {isPaid && (
          <div className="alert alert-error" data-testid="paid-warning">
            <strong>Esta cita está pagada{appointment.payment?.amount ? ` (${fmtCOP(appointment.payment.amount)})` : ''}.</strong>{' '}
            El pago quedará marcado como reembolsado; el reembolso en Wompi/banco lo haces por fuera.
          </div>
        )}

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="edit-appt-form">
          <label>Motivo (obligatorio)
            <textarea
              value={reason}
              rows={3}
              maxLength={500}
              autoFocus
              onChange={e => setReason(e.target.value)}
              placeholder="Ej.: cita duplicada por doble pago"
            />
          </label>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Volver</button>
            <button type="submit" className="btn-delete-confirm" disabled={saving || !reason.trim()}>
              {saving ? 'Eliminando...' : 'Eliminar definitivamente'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
